export * from './fetch'
export * from './fetchNIN'
export * from './saveFetch'
export * from './values'

export const TRN_MATCH_BIOSEC_RESET = 'TRN_MATCH_BIOSEC_RESET'

export const matchBiosecurityReset = () => ({
  payload: null,
  type: TRN_MATCH_BIOSEC_RESET,
})
